<script lang="ts">
import Breadcrumbs from "../../components/breadcrumbs.svelte";
import type { Breadcrumb } from "../../components/breadcrumbs.svelte";
import type { PageData } from "./$types";
import { onMount } from "svelte";

const breadcrumbs: Breadcrumb[] = [
	{ label: "トップ", href: "/" },
	{ label: "ブリッジ制度", href: "/otherschools/" },
];

export let data: PageData;

const initializeResponsiveTables = () => {
	const tables = document.querySelectorAll("article table");

	tables.forEach((table, tableIndex) => {
		const columnCount = table.querySelector("tr")?.children.length || 0;

		if (columnCount >= 3) {
			table.classList.add("responsive-table");

			const headerRow = table.querySelector("tr:first-child");
			const headers = Array.from(headerRow?.querySelectorAll("th") || [])
				.map((th) => th.textContent?.trim())
				.filter((header) => header && header.length > 0);

			const rows = Array.from(table.querySelectorAll("tr:not(:first-child)"));

			rows.forEach((row, rowIndex) => {
				const cells = Array.from(row.querySelectorAll("td:not(:first-child)"));

				cells.forEach((cell, index) => {
					const header = headers[index];
					if (header) {
						cell.setAttribute("data-header", header);
					}
				});
			});
		}
	});
};

onMount(() => {
	setTimeout(() => {
		initializeResponsiveTables();
	}, 0);
});
</script>

<Breadcrumbs breadcrumbs={breadcrumbs} />
<div class="inner bg-bgGray pt-8">
  <section class="px-6 bg-white rounded-xl mb-4">
    <article class="content">
      <h1 class="mb-10">
        {data.title}
      </h1>
      {@html data.content}
    </article>
  </section>
</div>